import React, { useEffect, useState } from "react";
import axios from "axios";
import "./forecast.css";
import ReactAnimatedWeather from "react-animated-weather";
import { useGlobalWeather } from "./Stores";

export default function ForeCast(props) {
  const lat = props.data.lat;
  const lon = props.data.lon;
  const [foreCastData, setForcastData] = useState({ loaded: false });
  const { setGlobalWeather } = useGlobalWeather();

  // console.log(globalState);

  useEffect(() => {
    setForcastData({
      loaded: false,
    });
    setClickedButtonIndex(0);
  }, [props.data.lat]);
  const codeMapping = {
    "01d": "CLEAR_DAY",
    "01n": "CLEAR_NIGHT",
    "02d": "PARTLY_CLOUDY_DAY",
    "02n": "PARTLY_CLOUDY_NIGHT",
    "03d": "PARTLY_CLOUDY_DAY",
    "03n": "PARTLY_CLOUDY_NIGHT",
    "04d": "CLOUDY",
    "04n": "CLOUDY",
    "09d": "RAIN",
    "09n": "RAIN",
    "10d": "RAIN",
    "10n": "RAIN",
    "11d": "RAIN",
    "11n": "RAIN",
    "13d": "SNOW",
    "13n": "SNOW",
    "50d": "FOG",
    "50n": "FOG",
  };

  function currentDay(timestamp) {
    const currentDate = new Date(timestamp * 1000);
    const options = { weekday: "short", timeZone: "UTC", weekdayLang: "en" };
    const currentDayOfWeek = currentDate.toLocaleDateString("en-US", options);
    return currentDayOfWeek;
  }
  const [clickedButtonIndex, setClickedButtonIndex] = useState(0);
  function changeTemp(index) {
    setClickedButtonIndex(index);

    setGlobalWeather((prevGlobalState) => ({
      ...prevGlobalState,
      loaded: true,
      temp: foreCastData.daily[index].temp.max,
      humidity: foreCastData.daily[index].humidity,
      wind: Math.round(foreCastData.daily[index].wind_speed),
      description: foreCastData.daily[index].weather[0].description,
      icon: foreCastData.daily[index].weather[0].icon,
      dt: foreCastData.daily[index].dt,
    }));
  }

  if (foreCastData.loaded) {
    return (
      <div>
        <ul className="d-flex list-unstyled justify-content-evenly text-center mb-0">
          {foreCastData.daily.map((dailyForcast, index) => {
            if (index < 6) {
              return (
                <li
                  className={`day pt-0 ${
                    clickedButtonIndex === index ? "day-clicked" : ""
                  }`}
                  key={index}
                  onClick={() => changeTemp(index)}
                >
                  <span>{currentDay(dailyForcast.dt)}</span>
                  <br />
                  <br />
                  <span>
                    <ReactAnimatedWeather
                      icon={codeMapping[dailyForcast.weather[0].icon]}
                      color={"black"}
                      size={35}
                      animate={true}
                    />
                  </span>
                  <p className="mb-0">
                    <span className="max-temp me-1">
                      {Math.round(dailyForcast.temp.max)}°
                    </span>
                    <span className="max-temp text-muted">
                      {Math.round(dailyForcast.temp.min)}°
                    </span>
                  </p>
                </li>
              );
            } else {
              return null;
            }
          })}
        </ul>
      </div>
    );
  } else {
    const apiKey = "50fa4024e3b1d5eac2f51ab18a47e997";
    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then((response) => {
      setForcastData({
        loaded: true,
        daily: response.data.daily,
      });
    });
    return null;
  }
}
